import { makePostApiCall } from "./makeApiCall";
import type { ApiResult } from "../types/api";

export interface UnavailableOrderProduct {
  product_id: number;
  product_name: string;
  reason: "not_available_for_customer_group" | "product_not_found";
}

export interface OrderAvailabilityResponse {
  available_product_ids: number[];
  unavailable_products: UnavailableOrderProduct[];
}

export function validateOrderProducts(
  customerId: number,
  productIds: number[]
): Promise<ApiResult<OrderAvailabilityResponse>> {
  return makePostApiCall<OrderAvailabilityResponse, { customer_id: number; product_ids: number[] }>(
    "validateOrderProducts",
    { customer_id: customerId, product_ids: productIds }
  );
}
